import EventEmitter from 'eventemitter3'
import FTTrickPlayOptions from "./ft-trickplay-options";
import { Registry } from '@lightningjs/sdk';

class FTTrickPlayInterface extends EventEmitter {

    options: FTTrickPlayOptions;
    prevIndex = -1;
    thumbnailList = [];

    prefetchSize = 10;
    nextPageIndex = -1;
    prevPageIndex = -1;

    isInteractive = false;
    currentThumbnailIndex = 0;

    canShow = false;
    isShown = false;
    autoHideTimerId: any = null;
    AUTO_HIDE_INTERVAL = 10;//in seconds
    autoHideCounter = 0;
    duration = -1;

    constructor(options: FTTrickPlayOptions) {
        super()
        this.options = new FTTrickPlayOptions();
        Object.assign(this.options, options);
    }

    init() {
        const urlObj = new URL(this.options.url);
        const securityToken = urlObj.searchParams.get('token');
        // Remove token from URL
        urlObj.searchParams.delete('token');
        // Use the updated URL (without token)
        const cleanedUrl = urlObj.toString();        
        if (cleanedUrl) {
            const fetchOptions = {
                method: 'GET'
            };
            if (securityToken) {
                fetchOptions.headers = {
                    'token': `${securityToken}`
                };
            }
            fetch(cleanedUrl, fetchOptions)
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    let indx = 0;
                    for (let [key, value] of Object.entries(json.tp)) {

                        const stime = parseInt(key);
                        let imgs = '';

                        if (this.thumbnailList.length == 0 && stime > 0) {
                            imgs = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
                            this.thumbnailList.push({ stime: 0, etime: -1, imageUrl: imgs });
                        }
                        imgs = value;
                        this.thumbnailList.push({ stime: stime, etime: -1, imageUrl: imgs });
                    }
                    //loop through the thumbnail array and mark the current index end time by next index startTime -1;
                    for (let i = 0; i <= (this.thumbnailList.length - 2); i++) {
                        let nextMarker = this.thumbnailList[i + 1];
                        this.thumbnailList[i].etime = nextMarker.stime;
                    }
                    let ref = this;
                    let loadTestImage = new Image();
                    loadTestImage.onload = () => {
                        this.canShow = true;
                        this.createThumbnailContainer();
                    }
                    loadTestImage.onerror = () => {
                        this.onTrickplayError();
                    }
                    loadTestImage.src = this.thumbnailList[1].imageUrl;
                })
                .catch(e => {
                });
        }
        //this.createThumbnailContainer();
    }

    onTrickplayError = () => {
        this.canShow = false;
        const event = new CustomEvent('trickplayError', {
            detail: null,
            bubbles: true,
            cancelable: true,
            composed: false,
        })
        this._dispatchEvent(event);
        //this.options.videoElement.dispatchEvent(event);
    }

    getClass = (isSelected, isInteractive) => {
        let ret = '';
        if (isSelected && isInteractive) {
            ret = 'interactive';
        } else if (isSelected) {
            ret = 'center';
        }
        return ret;
    }
    getThumbnailTemplate = (item, isCenter, isInteractive) => {
        const temp = `
            <div class="trickplay-item" style="transform: translate3d(0,0,0);margin:5px">
                <h4 style="text-align:center!important;font-size:1.3rem;margin-top:0;margin-bottom:0.5rem;line-height:1.2;color:#ddd" class="text-center"><div style="width:5vw;display:inline-block;font-size: 1.8vh;font-family: 'Regular';">${isCenter ? 'TIMESHOT: ' : ''}</div><div style="width:5vw;display:inline-block;font-size: 1.8vh;font-family: 'Regular';" id="time_shot">${isCenter ? item.time : ''}</div></h4>
                <img style="width:20vw;height:20vh;border:0.4em solid rgba(0, 0, 0, 0);max-width:100%;" class="img-fluid ${this.getClass(isCenter, isInteractive)}" src="${item.image}">
            </div>
        `;
        return temp;
    }

    createThumbnailContainer() {
        const template = `
        <div id="trickplay-wrapper" style="height:100%!important;width:100%!important;justify-content:center!important;display:flex!important" class="d-flex h-100 w-100 justify-content-center align-item-center">

        </div>
        `
        if (this.options.thumbnailContainer) {
            $(this.options.thumbnailContainer).hide();
            $(this.options.thumbnailContainer).empty();
            $(this.options.thumbnailContainer).append(template);
        }
        /*if (this.options.videoElement) {
            this.options.videoElement.addEventListener('trickplay', this.renderTrickPlayImages)
        }*/
    }


    renderTrickPlayImages = (event) => {
        const imgList = event.detail;
        if ($('#trickplay-wrapper').children().length > 0) {
            imgList.map((item, index) => {
                const selected = Math.floor(this.options.noOfThumbs / 2) == index;
                const newClass = 'img-fluid ' + this.getClass(selected, this.isInteractive)
                $($('#trickplay-wrapper img')[index]).attr("class", newClass);
                $('#trickplay-wrapper img')[index].src = item.image;
                if (selected) {
                    $('#trickplay-wrapper #time_shot')[index].innerHTML = item.time;
                }
            });
        } else {
            var fragment = document.createDocumentFragment();
            imgList.map((item, index) => {
                const selected = Math.floor(this.options.noOfThumbs / 2) == index;
                var temp = this.getThumbnailTemplate(item, selected, this.isInteractive);
                $(fragment).append(temp);
            });
            $('#trickplay-wrapper').empty();
            $('#trickplay-wrapper').append(fragment);
        }
        if (this.isInteractive) {
            $(".trickplay-item .interactive").css({ border: "5px solid #fff" });
        } else {
            $(".trickplay-item .center").css({ border: "0.4em solid transparent" });
        }
    }

    setPlayerTime(currentTime, autoupdate = true, force = false) {
        if (!this.canShow) {
            return;
        }
        if (this.isInteractive && autoupdate) {
            return false;
        }
        if (this.options.videoElement) {
            this.dispatchThumbnailEvent(currentTime, force);
        }
    }

    setVideoDuration(duration) {
        this.duration = duration;
    }


    dispatchThumbnailEvent(currentTime, force = false) {
        const imgUrlArry = this.getImageAtTime(currentTime, force);
        if (imgUrlArry) {
            const event = new CustomEvent('trickplay', {
                detail: imgUrlArry,
                bubbles: true,
                cancelable: true,
                composed: false,
            })
            this._dispatchEvent(event);
            //this.options.videoElement.dispatchEvent(event);
        }
    }

    getImageAtTime(currentTime, force = false) {
        let indx = null;
        this.thumbnailList.some((value, index) => {
            let etime = value.etime;
            if (value.etime == -1) {
                try {
                    etime = this.duration;//this.options.videoElement.duration;
                } catch (e) {
                    etime = value.stime + 100; //for fall back endtime value for the last thumbnail on video duration.
                }
            }
            if (currentTime >= value.stime && currentTime < parseInt(etime)) {
                indx = index;
                return true;
            }
        });
        this.currentThumbnailIndex = indx;
        let retThumbArray = null;
        if (this.prevIndex !== indx || force) {
            const extendThumbIndex = (this.options.noOfThumbs - 1) / 2;
            retThumbArray = [];
            for (let i = (indx - extendThumbIndex); i <= indx + extendThumbIndex; i++) {
                if (i < 0 || i > this.thumbnailList.length - 1) {
                    retThumbArray.push(
                        {
                            image: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
                            time: this.secondsToHHMMSS('')
                        });
                } else {

                    if (!this.thumbnailList[i].fetched) {
                        this.thumbnailList[i].img = new Image();
                        this.thumbnailList[i].img.src = this.thumbnailList[i].imageUrl;
                        this.thumbnailList[i].fetched = true;
                        fetch(this.thumbnailList[i].imageUrl)
                            .then(res => res.blob())
                            .then(blob => {
                                let objectURL = URL.createObjectURL(blob);
                                if (objectURL) {
                                    if (this.thumbnailList && this.thumbnailList[i]) {
                                        this.thumbnailList[i].blob = objectURL;
                                    }
                                }
                            });
                    }
                    let image = this.thumbnailList[i].imageUrl;
                    if (this.thumbnailList[i].blob) {
                        image = this.thumbnailList[i].blob;
                    }
                    retThumbArray.push({
                        image: image,
                        time: this.secondsToHHMMSS(this.thumbnailList[i].stime)
                    });
                }
            }
            this.prevIndex = indx;
            try {
                this.prefetchImages(indx - extendThumbIndex, indx + extendThumbIndex);
            } catch (e) {
            }
        } else {
            return;
        }
        return retThumbArray;
    }

    prefetchImages(prev, next) {
        //left images
        let lstart;
        let lend;
        if (prev > -1) {
            if (this.prevPageIndex == -1) {
                lstart = prev - this.options.noOfThumbs;
                lend = prev;
            } else {
                lstart = this.prevPageIndex - this.options.noOfThumbs;
                lend = this.prevPageIndex;
            }
            for (let i = lstart; i <= lend; i++) {
                if (i > -1) {
                    if (!this.thumbnailList[i].fetched) {
                        this.thumbnailList[i].img = new Image();
                        this.thumbnailList[i].img.src = this.thumbnailList[i].imageUrl;
                        this.thumbnailList[i].fetched = true;
                        fetch(this.thumbnailList[i].imageUrl)
                            .then(res => res.blob())
                            .then(blob => {
                                let objectURL = URL.createObjectURL(blob);
                                if (objectURL) {
                                    if (this.thumbnailList && this.thumbnailList[i]) {
                                        this.thumbnailList[i].blob = objectURL;
                                    }
                                }
                            });
                    }
                    this.prevPageIndex = i;
                }
            }
        }
        //right images
        let start;
        let end;
        if (this.nextPageIndex == -1) {
            start = next + 1;
            end = start + this.options.noOfThumbs;
        } else {
            start = this.nextPageIndex + 1;
            end = start + this.options.noOfThumbs;
        }
        for (let i = start; i <= end; i++) {
            if (i < this.thumbnailList.length - 1) {
                if (!this.thumbnailList[i].fetched) {
                    this.thumbnailList[i].img = new Image();
                    this.thumbnailList[i].img.src = this.thumbnailList[i].imageUrl;
                    this.thumbnailList[i].fetched = true;
                    fetch(this.thumbnailList[i].imageUrl)
                        .then(res => res.blob())
                        .then(blob => {
                            let objectURL = URL.createObjectURL(blob);
                            if (objectURL) {
                                if (this.thumbnailList && this.thumbnailList[i]) {
                                    this.thumbnailList[i].blob = objectURL;
                                }
                            }
                        });

                }
                this.nextPageIndex = i;

            }
        }
    }

    show(isInteractive = false) {
        $(this.options.thumbnailContainer).show();
        if (isInteractive) {
            this.isInteractive = true;

        } else {
            this.isInteractive = false;
        }
        if (this.thumbnailList && this.thumbnailList[this.currentThumbnailIndex] && this.thumbnailList[this.currentThumbnailIndex].stime) {
            this.setPlayerTime(this.thumbnailList[this.currentThumbnailIndex].stime, false, true);
        }
        const event = new CustomEvent('trickplayShow', {
            detail: null,
            bubbles: true,
            cancelable: true,
            composed: false,
        })
        this._dispatchEvent(event);
        //this.options.videoElement.dispatchEvent(event);
        this.isShown = true;
        this.stopAutoHideTimer(); // stopping any previous timeout
        if(this.isInteractive){
            this.startAutoHideTimer(); //check condition to start autohide timeout only if the show type is interactive.
        }
    }

    startAutoHideTimer = () => {
        let timer = 1000;
        this.stopAutoHideTimer();
        this.autoHideTimerId = setInterval(() => {
            this.autoHideCounter++;
            if (this.autoHideCounter >= this.AUTO_HIDE_INTERVAL) {
                this.hide();
                const event = new CustomEvent('trickplayAutoHide', {
                    detail: null,
                    bubbles: true,
                    cancelable: true,
                    composed: false,
                })
                this._dispatchEvent(event);

            }
        }, timer);
    };

    stopAutoHideTimer = () => {
        clearInterval(this.autoHideTimerId);
        this.autoHideTimerId = null;
        this.autoHideCounter = 0;
    };

    hide() {
        this.stopAutoHideTimer();
        if (!this.isShown) {
            return;
        }
        this.isShown = false;
        this.isInteractive = false;
        if (this.options && this.options.thumbnailContainer) {
            $(this.options.thumbnailContainer).hide();
        }
        const event = new CustomEvent('trickplayHide', {
            detail: null,
            bubbles: true,
            cancelable: true,
            composed: false,
        })
        this._dispatchEvent(event);
        //this.options.videoElement.dispatchEvent(event);
    }

    isVisible() {
        return $(this.options.thumbnailContainer).is(":visible");
    }

    /*keyEventHandler = (event) => {
        if (event.type == 'click') {
            if ($(event.target).hasClass('playercontrol')) {
                const id = $(event.target).attr('id');
                this.setCurrentFocusIndex('#' + id);
                this.processOk();
            } else {
                return false;
            }
        } else {
            const keyCode = event.keyCode;
            switch (keyCode) {
                case 37:
                    this.moveLeft();
                    break;
                case 39:
                    this.moveRight();
                    break;
                case 8:
                    this.hide();
                    break;
                case 13:
                    this.processOk();
                    break;
            }
        }
    }*/

    processOk() {
        if (this.thumbnailList && this.thumbnailList[this.currentThumbnailIndex] && this.thumbnailList[this.currentThumbnailIndex].stime != undefined && this.thumbnailList[this.currentThumbnailIndex].stime != null) {
            const event = new CustomEvent('trickplaySelected', {
                detail: this.thumbnailList[this.currentThumbnailIndex].stime,
                bubbles: true,
                cancelable: true,
                composed: false,
            })
            this._dispatchEvent(event);
            //this.options.videoElement.dispatchEvent(event);
            this.hide();
        }
    }

    moveRight() {
        this.autoHideCounter = 0;
        const nextIndx = this.currentThumbnailIndex + 1;
        if (nextIndx < this.thumbnailList.length) {
            const time = this.thumbnailList[nextIndx].stime;
            this.setPlayerTime(time, false);
        }
    }

    setInteractive(isInteractive: boolean) {
        this.isInteractive = isInteractive;
        if (isInteractive) {
            $(".trickplay-item img.center").removeClass("center").addClass("interactive");
            $(".trickplay-item .interactive").css({ border: "5px solid #fff" });
        } else {
            $(".trickplay-item img.interactive").removeClass("interactive").addClass("center");
            $(".trickplay-item .center").css({ border: "5px solid transparent" });
        }
    }

    moveLeft() {
        this.autoHideCounter = 0;
        const prevIndx = this.currentThumbnailIndex - 1;
        if (prevIndx <   this.thumbnailList.length - 1) {
            if (this.thumbnailList[prevIndx]) {
                const time = this.thumbnailList[prevIndx].stime;
                this.setPlayerTime(time, false);
            }
        }
    }

    destroy() {
        //this.options.videoElement.removeEventListener('trickplay', this.renderTrickPlayImages);
        $(this.options.thumbnailContainer).empty();
        this.options = null;
        this.prevIndex = -1;
        this.thumbnailList = [];
        this.hide();
    }

    secondsToHHMMSS = (seconds) => {
        if (seconds !== '') {
            return new Date(seconds * 1000).toISOString().substring(11, 19);
        }
        return '';
    }

    _dispatchEvent(event: CustomEvent) {
        this.emit(event.type, event);
    }

}

export default FTTrickPlayInterface
